<kui-input-group [cleanAddons]="true" class="w-100 d-flex">
    <div kui-input>
        <span (click)="openPresets()">{{ getDayPresetText(dayValue) }}</span>
        @if (!showTimeInput) {
            <span class="ml-3">{{ timeValue }}</span>
        }

        @if (showTimeInput) {
            <input type="time" class="time-input ml-1" [ngModel]="timeValue" (ngModelChange)="changeTime($event)" />
        }
    </div>

    <span kui-input-group-addon class="p-0">
        <kui-dropdown [menu]="dayPresetDropdownValues" [style]="'none'">
            <kui-icon name="calendar-day" size="xs" class="py-2 px-3"></kui-icon>
        </kui-dropdown>
    </span>
</kui-input-group>

@if (invalidTimeError) {
    <div class="invalid-feedback d-block">
        <div>{{ "FORMS.DAYTIME.INVALID_TIME" | translate }}</div>
    </div>
}
@if (error) {
    <div class="invalid-feedback d-block">
        <div>{{ error }}</div>
    </div>
}
